import { StandardEvents, CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { formatMoney } from '@theme/money-formatting';

/* FAQ */
document.querySelectorAll('.brite-faq__item').forEach(function (item) {
  var button = item.querySelector('.brite-faq__item-summary');
  var answer = item.querySelector('[data-faq-answer]');
  if (!button || !answer) return;

  if (item.classList.contains('is-open')) {
    requestAnimationFrame(function () {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    });
  }

  item.addEventListener('click', function () {
    var isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        answer.style.maxHeight = '0px';
      });
    } else {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';

      var onEnd = function (e) {
        if (e.propertyName === 'max-height') {
          answer.style.maxHeight = 'none';
          answer.removeEventListener('transitionend', onEnd);
        }
      };
      answer.addEventListener('transitionend', onEnd);
    }
  });
});

/* UGC carousel */
function initBriteUgcVideoCarousel() {
  var mq = window.matchMedia('(max-width: 989px)');
  var instances = new WeakMap();

  function setup() {
    document.querySelectorAll('.brite-ugc__videos-outer').forEach(function (wrapper) {
      var el = wrapper.querySelector('.brite-ugc__videos');
      if (!el) return;

      if (mq.matches) {
        if (!instances.has(el)) {
          instances.set(el, new Swiper(el, {
            slidesPerView: 1.15,
            centeredSlides: true,
            spaceBetween: 12,
            initialSlide: 1,
            navigation: {
              nextEl: wrapper.querySelector('.brite-ugc__videos-next'),
              prevEl: wrapper.querySelector('.brite-ugc__videos-prev')
            },
            pagination: {
              el: wrapper.querySelector('.brite-ugc__videos-pagination'),
              clickable: true
            },
            breakpoints: {
              750: {
                slidesPerView: 3.15,
                initialSlide: 2,
                centeredSlides: true,
                spaceBetween: 16
              }
            }
          }));
        }
      } else if (instances.has(el)) {
        instances.get(el).destroy(true, true);
        instances.delete(el);
      }
    });
  }

  setup();
  mq.addEventListener('change', setup);
}

if (window.Swiper) {
  initBriteUgcVideoCarousel();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.Swiper) initBriteUgcVideoCarousel();
  });
}

/* Footer market selector */
document.querySelectorAll('.footer-about__market').forEach(function (market) {
  var toggle = market.querySelector('[data-market-toggle]');
  var list = market.querySelector('[data-market-list]');
  if (!toggle || !list) return;

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    list.hidden = isOpen;
  });

  document.addEventListener('click', function (event) {
    if (!market.contains(event.target)) {
      toggle.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    }
  });
});

/* Header market selector */
document.querySelectorAll('.header-market-selector').forEach(function (market) {
  var toggle = market.querySelector('[data-market-toggle]');
  var list = market.querySelector('[data-market-list]');
  if (!toggle || !list) return;

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    list.hidden = isOpen;
  });

  document.addEventListener('click', function (event) {
    if (!market.contains(event.target)) {
      toggle.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    }
  });
});

/* Click backdrop to close the cart */
document.addEventListener('click', (event) => {
  if (event.target !== document.body) return;
  if (!document.getElementById('cart-drawer')?.hasAttribute('open')) return;
  document.getElementById('cart-drawer').close();
});

/* Cart upsells carousel */
(function () {
  function initSwiperInstance(container) {
    var el = container.querySelector('.cart-upsells__swiper');
    if (!el) return;

    if (el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {
      }
    }

    var prevBtn = container.querySelector('.cart-upsells__nav-btn--prev');
    var nextBtn = container.querySelector('.cart-upsells__nav-btn--next');

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });
  }

  function initCartUpsells() {
    var containers = document.querySelectorAll('.cart-upsells');
    if (!containers.length) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(initCartUpsells, 50);
      return;
    }

    containers.forEach(initSwiperInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUpsells);
  } else {
    initCartUpsells();
  }

  document.addEventListener('theme-drawer:open', initCartUpsells);

  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    event.promise?.then(function () {
      initCartUpsells();
    }).catch(function () {});
  });
})();

/* Product accordions */
(function () {
  document.addEventListener('click', function (event) {
    var details = event.target.closest('.product-details .accordion .details[data-testid="accordion-details"]');
    if (!details) return;

    if (event.target.closest('.details-content')) return;
    if (event.target.closest('[data-accordion-close]')) return;

    event.preventDefault();
    details.open = !details.open;
  });
})();

/* Homepage sticky product bar - show after scrolling past the first section, hide at the footer */
(function () {
  function initHomepageStickyBar() {
    var bar = document.querySelector('.sticky-add-to-cart__bar[data-homepage-sticky-bar]');
    if (!bar) return;

    var ownSection = bar.closest('.shopify-section');
    var candidateSections = Array.prototype.slice.call(
      document.querySelectorAll('#MainContent .shopify-section')
    );
    var firstSection = candidateSections.filter(function (section) {
      return section !== ownSection;
    })[0];
    if (!firstSection) return;

    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');

    var pastFirstSection = false;
    var atFooter = false;

    function updateVisibility() {
      bar.dataset.stuck = pastFirstSection && !atFooter ? 'true' : 'false';
    }

    var firstSectionObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;

      if (entry.isIntersecting) {
        pastFirstSection = false;
      } else {
        var rect = entry.target.getBoundingClientRect();
        if (rect.bottom < 0) {
          pastFirstSection = true;
        }
      }

      updateVisibility();
    });
    firstSectionObserver.observe(firstSection);

    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          atFooter = entry.isIntersecting;
          updateVisibility();
        },
        { rootMargin: '200px 0px 0px 0px' }
      );
      footerObserver.observe(footer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomepageStickyBar);
  } else {
    initHomepageStickyBar();
  }
})();

/* Brite quantity block */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function updateItemUI(item) {
    var input = item.querySelector('[data-brite-qty-input]');
    var display = item.querySelector('[data-brite-qty-display]');
    var decreaseBtn = item.querySelector('[data-brite-qty-decrease]');
    var increaseBtn = item.querySelector('[data-brite-qty-increase]');
    if (!input || !display) return;

    var min = parseInt(input.min || '0', 10);
    var max = parseInt(input.max || '0', 10);
    var qty = clamp(parseInt(input.value, 10) || 0, min, max);
    input.value = qty;
    display.textContent = qty;

    item.classList.toggle('brite-quantity__item--selected', qty > 0);
    if (decreaseBtn) decreaseBtn.disabled = qty <= min;
    if (increaseBtn) increaseBtn.disabled = qty >= max;
  }

  function getSelectedTotals(picker) {
    var quantity = 0;
    var price = 0;

    picker.querySelectorAll('[data-brite-qty-item]').forEach(function (item) {
      var input = item.querySelector('[data-brite-qty-input]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        quantity += qty;
        price += qty * (parseInt(item.dataset.price, 10) || 0);
      }
    });

    return { quantity: quantity, price: price };
  }

  function findSubscriptionWidget(picker) {
    return document.querySelector(
      '[data-brite-subscription][data-main-product-id="' + picker.dataset.mainProductId + '"]'
    );
  }

  function findPickerForSubscriptionWidget(widget) {
    return document.querySelector(
      '[data-brite-quantity-picker][data-main-product-id="' + widget.dataset.mainProductId + '"]'
    );
  }

  function getSelectedSellingPlan(picker) {
    var widget = findSubscriptionWidget(picker);
    if (!widget) return null;

    var selectedRadio = widget.querySelector('[data-brite-sub-radio]:checked');
    if (!selectedRadio || selectedRadio.value !== 'subscription') return null;

    var select = widget.querySelector('[data-brite-sub-frequency]');
    if (!select || !select.value) return null;

    var id = parseInt(select.value, 10);
    return isNaN(id) ? null : id;
  }

  function getSelectedLines(picker) {
    var lines = [];
    var sellingPlan = getSelectedSellingPlan(picker);

    picker.querySelectorAll('[data-brite-qty-item]').forEach(function (item) {
      var input = item.querySelector('[data-brite-qty-input]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        var line = { id: parseInt(item.dataset.variantId, 10), quantity: qty };
        if (sellingPlan) line.selling_plan = sellingPlan;
        lines.push(line);
      }
    });
    return lines;
  }

  function updateTiers(picker, totals) {
    var tiersEl = picker.querySelector('[data-brite-tiers]');
    if (!tiersEl) return;

    var activeTier = Math.min(totals.quantity, 3);

    var dots = tiersEl.querySelectorAll('[data-brite-tier-dot]');
    dots.forEach(function (dot) {
      var index = parseInt(dot.dataset.briteTierDot, 10);
      dot.classList.toggle('brite-quantity__tier-dot--active', index <= activeTier);
    });

    var track = tiersEl.querySelector('[data-brite-tiers-track]');
    var line = tiersEl.querySelector('[data-brite-tiers-line]');
    var fill = tiersEl.querySelector('[data-brite-tiers-fill]');
    var firstDot = tiersEl.querySelector('[data-brite-tier-dot="1"]');
    if (!track || !line || !fill || !firstDot) return;

    var trackRect = track.getBoundingClientRect();
    var firstDotRect = firstDot.getBoundingClientRect();
    var centerY = firstDotRect.top + firstDotRect.height / 2 - trackRect.top;
    line.style.top = centerY + 'px';
    fill.style.top = centerY + 'px';

    if (activeTier <= 0) {
      fill.style.width = '0px';
      return;
    }

    if (activeTier >= 3) {
      fill.style.width = '100%';
      return;
    }

    var activeDot = tiersEl.querySelector('[data-brite-tier-dot="' + activeTier + '"]');
    if (!activeDot) return;

    var dotRect = activeDot.getBoundingClientRect();
    var dotCenter = dotRect.left + dotRect.width / 2 - trackRect.left;
    fill.style.width = Math.max(0, dotCenter) + 'px';
  }

  function findAddToCartForms(productId) {
    if (!productId) return [];
    var roots = document.querySelectorAll('product-form-component[data-product-id="' + productId + '"]');
    var forms = [];
    roots.forEach(function (root) {
      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      if (form) forms.push(form);
    });
    return forms;
  }

  function findStickyAddToCartButtons(productId) {
    if (!productId) return [];
    var roots = document.querySelectorAll('sticky-add-to-cart[data-product-id="' + productId + '"]');
    var buttons = [];
    roots.forEach(function (root) {
      var button = root.querySelector('[ref="addToCartButton"]');
      if (button) buttons.push(button);
    });
    return buttons;
  }

  function getPriceTextNode(button) {
    return Array.prototype.find.call(button.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
    });
  }

  function getRelabeledOriginal(original, dashIndex) {
    var picker = document.querySelector('[data-brite-quantity-picker][data-add-to-cart-text]');
    var label = picker && picker.dataset.addToCartText ? picker.dataset.addToCartText.trim() : '';
    if (!label) return original;
    return label + ' —' + original.slice(dashIndex + 1);
  }

  function updateButtonPrice(button, totals, comparePriceCents, moneyFormat, currency) {
    var textNode = getPriceTextNode(button);
    if (!textNode) return;

    if (button.dataset.briteOriginalText === undefined) {
      button.dataset.briteOriginalText = textNode.textContent;
    }

    var original = button.dataset.briteOriginalText;
    var dashIndex = original.lastIndexOf('—');
    if (dashIndex === -1) return;

    var relabeled = getRelabeledOriginal(original, dashIndex);
    var compareEl = button.querySelector('[data-brite-compare-price]');

    if (totals.quantity === 0) {
      textNode.textContent = relabeled;
      if (compareEl) compareEl.hidden = true;
      return;
    }

    var prefix = relabeled.slice(0, relabeled.lastIndexOf('—') + 1);
    textNode.textContent = prefix + ' ' + formatMoney(totals.price, moneyFormat, currency);

    if (compareEl) {
      if (comparePriceCents > totals.price) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function updateStickyButtonPrice(button, totals, comparePriceCents, moneyFormat, currency) {
    var contentEl = button.querySelector('.add-to-cart-text__content');
    if (!contentEl) return;

    var textEl = Array.prototype.find.call(contentEl.children, function (child) {
      return child.tagName === 'SPAN' && !child.hasAttribute('ref');
    });
    if (!textEl) return;

    if (button.dataset.briteOriginalText === undefined) {
      button.dataset.briteOriginalText = textEl.textContent;
    }

    var original = button.dataset.briteOriginalText;
    var dashIndex = original.lastIndexOf('—');
    if (dashIndex === -1) return;

    var relabeled = getRelabeledOriginal(original, dashIndex);
    var compareEl = contentEl.querySelector('[data-brite-compare-price]');

    if (totals.quantity === 0) {
      textEl.textContent = relabeled;
      if (compareEl) compareEl.hidden = true;
      return;
    }

    var prefix = relabeled.slice(0, relabeled.lastIndexOf('—') + 1);
    textEl.textContent = prefix + ' ' + formatMoney(totals.price, moneyFormat, currency);

    if (compareEl) {
      if (comparePriceCents > totals.price) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function updateBritePriceBlock(picker, totals, comparePriceCents, moneyFormat, currency) {
    var priceBlock = document.querySelector(
      '[data-brite-price][data-main-product-id="' + picker.dataset.mainProductId + '"]'
    );
    if (!priceBlock || totals.quantity === 0) return;

    var amountEl = priceBlock.querySelector('[data-brite-price-amount]');
    var compareEl = priceBlock.querySelector('[data-brite-price-compare]');
    var perUnitEl = priceBlock.querySelector('[data-brite-price-per-unit]');
    var cansCountEl = priceBlock.querySelector('[data-brite-price-cans-count]');
    var cansPerPack = parseInt(priceBlock.dataset.cansPerPack, 10) || 1;
    var totalCans = totals.quantity * cansPerPack;
    var perCan = totalCans ? Math.round(totals.price / totalCans) : totals.price;

    if (amountEl) amountEl.textContent = formatMoney(totals.price, moneyFormat, currency);
    if (compareEl) {
      if (comparePriceCents > totals.price) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
    if (perUnitEl) perUnitEl.textContent = formatMoney(perCan, moneyFormat, currency);
    if (cansCountEl) cansCountEl.textContent = totalCans;
  }

  function getTierNumber(quantity) {
    return Math.min(Math.max(quantity, 1), 3);
  }

  function getSubscriptionPricing(widget, totals) {
    var cansPerPack = parseInt(widget.dataset.cansPerPack, 10) || 1;
    var totalCans = totals.quantity * cansPerPack;
    var tier = getTierNumber(totals.quantity);
    var percent = parseFloat(widget.dataset['tier' + tier + 'Percent']) || 0;
    var badgeText = widget.dataset['tier' + tier + 'Badge'] || '';

    var subPrice = Math.round(totals.price * (1 - percent / 100));
    var subPerUnit = totalCans ? Math.round(subPrice / totalCans) : subPrice;
    var oneTimePerUnit = totalCans ? Math.round(totals.price / totalCans) : totals.price;

    return { subPrice: subPrice, subPerUnit: subPerUnit, oneTimePerUnit: oneTimePerUnit, badgeText: badgeText };
  }

  function findStickySubscriptionPills(productId) {
    if (!productId) return null;
    return document.querySelector('sticky-add-to-cart[data-product-id="' + productId + '"] [data-brite-sub-sticky]');
  }

  function setCheckedRadio(root, selector, value) {
    var radio = root.querySelector(selector + '[value="' + value + '"]');
    if (radio) radio.checked = true;
  }

  function updateStickySubscriptionPills(widget, totals, pricing, moneyFormat, currency, perUnitText) {
    var stickyPills = findStickySubscriptionPills(widget.dataset.mainProductId);
    if (!stickyPills) return;

    var sepHtml = '<span class="sticky-add-to-cart__sub-pill-sep">' +
      '<svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="2" cy="2" r="2" fill="#B5B5B5"/></svg></span>';

    var setHTML = function (selector, html) {
      var el = stickyPills.querySelector(selector);
      if (el) el.innerHTML = html;
    };

    setHTML(
      '[data-brite-sub-sticky-price]',
      formatMoney(pricing.subPrice, moneyFormat, currency) + ' ' + sepHtml + ' ' +
        formatMoney(pricing.subPerUnit, moneyFormat, currency) + ' ' + perUnitText
    );
    setHTML(
      '[data-brite-sub-sticky-onetime-price]',
      formatMoney(totals.price, moneyFormat, currency) + ' ' + sepHtml + ' ' +
        formatMoney(pricing.oneTimePerUnit, moneyFormat, currency) + ' ' + perUnitText
    );

    var badgeEl = stickyPills.querySelector('[data-brite-sub-sticky-badge]');
    if (badgeEl) {
      if (pricing.badgeText) {
        badgeEl.textContent = pricing.badgeText;
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    var bar = stickyPills.closest('.sticky-add-to-cart__bar');
    var packCansEl = bar && bar.querySelector('[data-brite-sticky-pack-cans]');
    if (packCansEl) {
      var cansPerPack = parseInt(widget.dataset.cansPerPack, 10) || 1;
      packCansEl.textContent = (totals.quantity * cansPerPack) + ' cans';
    }
  }

  function updateSubscriptionWidget(picker, totals, moneyFormat, currency) {
    var widget = findSubscriptionWidget(picker);
    if (!widget || totals.quantity === 0) return;

    var pricing = getSubscriptionPricing(widget, totals);
    var perUnitText = widget.dataset.perUnitText || '';

    var setText = function (selector, value) {
      var el = widget.querySelector(selector);
      if (el) el.textContent = value;
    };

    setText('[data-brite-sub-price]', formatMoney(pricing.subPrice, moneyFormat, currency));
    setText('[data-brite-sub-per-unit]', formatMoney(pricing.subPerUnit, moneyFormat, currency) + ' ' + perUnitText);
    setText('[data-brite-sub-compare]', formatMoney(totals.price, moneyFormat, currency));
    setText('[data-brite-sub-compare-per-unit]', formatMoney(pricing.oneTimePerUnit, moneyFormat, currency) + ' ' + perUnitText);
    setText('[data-brite-sub-onetime-price]', formatMoney(totals.price, moneyFormat, currency));
    setText('[data-brite-sub-onetime-per-unit]', formatMoney(pricing.oneTimePerUnit, moneyFormat, currency) + ' ' + perUnitText);

    var badgeEl = widget.querySelector('[data-brite-sub-badge]');
    if (badgeEl) badgeEl.textContent = pricing.badgeText;

    updateStickySubscriptionPills(widget, totals, pricing, moneyFormat, currency, perUnitText);
  }

  function updateTiersVisibility(widget) {
    var picker = findPickerForSubscriptionWidget(widget);
    if (!picker) return;
    var tiersEl = picker.querySelector('[data-brite-tiers]');
    if (!tiersEl) return;

    var selectedRadio = widget.querySelector('[data-brite-sub-radio]:checked');
    tiersEl.hidden = !!(selectedRadio && selectedRadio.value === 'onetime');
  }

  function safeRun(fn) {
    try {
      fn();
    } catch (error) {
      console.error('[brite-quantity] price sync failed', error);
    }
  }

  function updatePriceDisplays(picker, totals) {
    var moneyFormat = picker.dataset.moneyFormat || '{{amount}}';
    var currency = picker.dataset.currency || '';

    var widget = findSubscriptionWidget(picker);
    var sellingPlan = getSelectedSellingPlan(picker);
    var buttonTotals = totals;
    if (widget && sellingPlan) {
      var pricing = getSubscriptionPricing(widget, totals);
      buttonTotals = { quantity: totals.quantity, price: pricing.subPrice };
    }
    var comparePriceCents = buttonTotals.price < totals.price ? totals.price : 0;

    findAddToCartForms(picker.dataset.mainProductId).forEach(function (form) {
      var button = form.querySelector('[ref="addToCartButton"]');
      if (button) safeRun(function () { updateButtonPrice(button, buttonTotals, comparePriceCents, moneyFormat, currency); });
    });

    findStickyAddToCartButtons(picker.dataset.mainProductId).forEach(function (button) {
      safeRun(function () { updateStickyButtonPrice(button, buttonTotals, comparePriceCents, moneyFormat, currency); });
    });

    safeRun(function () { updateBritePriceBlock(picker, buttonTotals, comparePriceCents, moneyFormat, currency); });
    safeRun(function () { updateSubscriptionWidget(picker, totals, moneyFormat, currency); });
  }

  function refreshDerivedUI(picker) {
    var totals = getSelectedTotals(picker);
    syncAddToCartState(picker, totals);
    updateTiers(picker, totals);
    updatePriceDisplays(picker, totals);
  }

  async function refreshCart() {
    var cartItemsComponent = document.querySelector('cart-items-component');
    if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
      if (window.customElements && customElements.whenDefined) {
        await customElements.whenDefined('cart-items-component');
      }
      return cartItemsComponent.fetchCartData();
    }

    var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    var response = await fetch(cartUrl + '.json', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Failed to fetch cart: ' + response.status);
    return response.json();
  }

  async function submitBundle(picker, lines, addToCartComponent) {
    if (addToCartComponent && typeof addToCartComponent.disable === 'function') {
      addToCartComponent.disable();
    }

    var errorEl = picker.querySelector('[data-brite-error]');
    var totalQuantity = lines.reduce(function (sum, line) {
      return sum + line.quantity;
    }, 0);

    var deferredEventPromise = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: lines.map(function (line) {
          return { merchandiseId: String(line.id), quantity: line.quantity };
        }),
        promise: deferredEventPromise.promise,
      })
    );

    var cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    try {
      var response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines }),
      });
      var result = await response.json();

      if (!response.ok || result.status) {
        document.dispatchEvent(
          new CartErrorEvent({
            error: (result && result.message) || 'Add to cart failed',
            code: 'INVALID',
          })
        );

        refreshCart()
          .then(function (ajaxCart) {
            deferredEventPromise.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: {
                didError: true,
                items: ajaxCart.items,
                source: 'brite-quantity',
                itemCount: totalQuantity,
              },
            });
          })
          .catch(function (error) {
            deferredEventPromise.reject(error);
          });

        if (errorEl) {
          errorEl.hidden = false;
          if (result && result.message) errorEl.textContent = result.message;
        }
        return;
      }

      var cart = await refreshCart();
      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'brite-quantity',
          itemCount: totalQuantity,
          didError: false,
        },
      });
    } catch (error) {
      console.error('[brite-quantity] add to cart failed', error);
      deferredEventPromise.reject(error);
      if (errorEl) errorEl.hidden = false;
    } finally {
      if (addToCartComponent && typeof addToCartComponent.enable === 'function') {
        addToCartComponent.enable();
      }
    }
  }

  function getPickerForForm(form) {
    var root = form.closest('product-form-component');
    if (!root) return null;
    var productId = root.dataset.productId;
    if (!productId) return null;
    return document.querySelector('[data-brite-quantity-picker][data-main-product-id="' + productId + '"]');
  }

  function handleFormSubmit(picker, event, form) {
    var lines = getSelectedLines(picker);
    var errorEl = picker.querySelector('[data-brite-error]');

    event.preventDefault();
    event.stopImmediatePropagation();

    if (lines.length === 0) {
      if (errorEl) errorEl.hidden = false;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (errorEl) errorEl.hidden = true;

    var addToCartComponent = form.querySelector('add-to-cart-component');
    submitBundle(picker, lines, addToCartComponent);
  }

  function forceEnableAddToCart(form) {
    var addToCartComponent = form.querySelector('add-to-cart-component');
    if (addToCartComponent && typeof addToCartComponent.enable === 'function') {
      addToCartComponent.enable();
      return;
    }
    var button = form.querySelector('[ref="addToCartButton"]');
    if (button) button.disabled = false;
  }

  function forceDisableAddToCart(form) {
    var addToCartComponent = form.querySelector('add-to-cart-component');
    if (addToCartComponent && typeof addToCartComponent.disable === 'function') {
      addToCartComponent.disable();
      return;
    }
    var button = form.querySelector('[ref="addToCartButton"]');
    if (button) button.disabled = true;
  }

  function syncAddToCartState(picker, totals) {
    var hasSelection = totals.quantity > 0;
    var productId = picker.dataset.mainProductId;

    findAddToCartForms(productId).forEach(function (form) {
      if (hasSelection) {
        forceEnableAddToCart(form);
      } else {
        forceDisableAddToCart(form);
      }
    });

    findStickyAddToCartButtons(productId).forEach(function (button) {
      button.disabled = !hasSelection;
    });
  }

  function handleGlobalSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.type !== 'add-to-cart-form') return;

    var picker = getPickerForForm(form);
    if (!picker) return;

    handleFormSubmit(picker, event, form);
  }

  function reconcileMainProductId(picker) {
    var currentId = picker.dataset.mainProductId;
    if (currentId && document.querySelector('product-form-component[data-product-id="' + currentId + '"]')) return;

    var scope = picker.closest('.shopify-section') || document;
    var form = scope.querySelector('product-form-component[data-product-id]') ||
      document.querySelector('product-form-component[data-product-id]');

    if (form && form.dataset.productId) {
      picker.dataset.mainProductId = form.dataset.productId;
    }
  }

  function initPicker(picker) {
    reconcileMainProductId(picker);
    refreshDerivedUI(picker);

    if (picker.dataset.briteInitialized === 'true') return;
    picker.dataset.briteInitialized = 'true';

    picker.querySelectorAll('[data-brite-qty-item]').forEach(updateItemUI);

    picker.addEventListener('click', function (event) {
      var increaseBtn = event.target.closest('[data-brite-qty-increase]');
      var decreaseBtn = event.target.closest('[data-brite-qty-decrease]');
      if (!increaseBtn && !decreaseBtn) return;

      var item = event.target.closest('[data-brite-qty-item]');
      if (!item) return;
      var input = item.querySelector('[data-brite-qty-input]');
      if (!input) return;

      var qty = parseInt(input.value, 10) || 0;
      input.value = increaseBtn ? qty + 1 : qty - 1;
      updateItemUI(item);
      refreshDerivedUI(picker);

      var errorEl = picker.querySelector('[data-brite-error]');
      if (errorEl && !errorEl.hidden && getSelectedLines(picker).length > 0) {
        errorEl.hidden = true;
      }
    });
  }

  function ensureStickyPackDetails(widget, stickyPills) {
    var bar = stickyPills.closest('.sticky-add-to-cart__bar');
    if (!bar) return;
    var details = bar.querySelector('.sticky-add-to-cart__details');
    if (!details) return;
    if (details.querySelector('.sticky-add-to-cart__pack-details')) return;

    var cansPerPack = widget.dataset.cansPerPack;
    var volumePerCan = widget.dataset.volumePerCan;
    if (!cansPerPack && !volumePerCan) return;

    var packEl = document.createElement('p');
    packEl.className = 'sticky-add-to-cart__pack-details';

    if (cansPerPack) {
      var cansSpan = document.createElement('span');
      cansSpan.setAttribute('data-brite-sticky-pack-cans', '');
      cansSpan.textContent = cansPerPack + ' cans';
      packEl.appendChild(cansSpan);
    }
    if (cansPerPack && volumePerCan) {
      var dot = document.createElement('span');
      dot.className = 'sticky-add-to-cart__pack-details-dot';
      dot.setAttribute('aria-hidden', 'true');
      packEl.appendChild(dot);
    }
    if (volumePerCan) {
      var volumeSpan = document.createElement('span');
      volumeSpan.textContent = volumePerCan + ' per can';
      packEl.appendChild(volumeSpan);
    }

    details.appendChild(packEl);
  }

  function initStickySubscriptionPills(widget) {
    var stickyPills = findStickySubscriptionPills(widget.dataset.mainProductId);
    if (!stickyPills) return;

    var subLabelSrc = widget.querySelector('.brite-subscription__card--subscription .brite-subscription__option-title');
    var subLabelDest = stickyPills.querySelector('[data-brite-sub-sticky-label]');
    if (subLabelSrc && subLabelDest) subLabelDest.textContent = subLabelSrc.textContent;

    var oneTimeLabelSrc = widget.querySelector('.brite-subscription__card--onetime .brite-subscription__option-title');
    var oneTimeLabelDest = stickyPills.querySelector('[data-brite-sub-sticky-onetime-label]');
    if (oneTimeLabelSrc && oneTimeLabelDest) oneTimeLabelDest.textContent = oneTimeLabelSrc.textContent;

    ensureStickyPackDetails(widget, stickyPills);

    var checkedRadio = widget.querySelector('[data-brite-sub-radio]:checked');
    if (checkedRadio) setCheckedRadio(stickyPills, '[data-brite-sub-sticky-radio]', checkedRadio.value);
    stickyPills.hidden = false;

    if (stickyPills.dataset.briteStickyInitialized === 'true') return;
    stickyPills.dataset.briteStickyInitialized = 'true';

    stickyPills.addEventListener('change', function (event) {
      if (!event.target.matches('[data-brite-sub-sticky-radio]')) return;
      setCheckedRadio(widget, '[data-brite-sub-radio]', event.target.value);
      updateTiersVisibility(widget);
      var picker = findPickerForSubscriptionWidget(widget);
      if (picker) refreshDerivedUI(picker);
    });
  }

  function initSubscriptionWidget(widget) {
    updateTiersVisibility(widget);
    initStickySubscriptionPills(widget);

    if (widget.dataset.briteSubInitialized === 'true') return;
    widget.dataset.briteSubInitialized = 'true';

    widget.addEventListener('change', function (event) {
      if (!event.target.matches('[data-brite-sub-radio]')) return;
      updateTiersVisibility(widget);
      var stickyPills = findStickySubscriptionPills(widget.dataset.mainProductId);
      if (stickyPills) setCheckedRadio(stickyPills, '[data-brite-sub-sticky-radio]', event.target.value);
      var picker = findPickerForSubscriptionWidget(widget);
      if (picker) refreshDerivedUI(picker);
    });

    widget.addEventListener('click', function (event) {
      if (!event.target.closest('.brite-subscription__frequency-label')) return;
      var select = widget.querySelector('[data-brite-sub-frequency]');
      if (!select) return;
      try {
        if (typeof select.showPicker === 'function') {
          select.showPicker();
        } else {
          select.focus();
        }
      } catch (error) {
        select.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-brite-quantity-picker]').forEach(initPicker);
    document.querySelectorAll('[data-brite-subscription]').forEach(initSubscriptionWidget);
  }

  function refreshAll() {
    document.querySelectorAll('[data-brite-quantity-picker]').forEach(refreshDerivedUI);
  }

  window.addEventListener('submit', handleGlobalSubmit, { capture: true });

  ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener(StandardEvents.productSelect, initAll);

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(refreshAll, 150);
  });
})();

/* Brite subscription button sync when quantity block is not present */
(function () {
  function getPriceTextNode(button) {
    return Array.prototype.find.call(button.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
    });
  }

  function setButtonPrice(button, priceCents, comparePriceCents, moneyFormat, currency) {
    if (!button) return;
    var textNode = getPriceTextNode(button);
    if (!textNode) return;

    if (button.dataset.briteSubOriginalText === undefined) {
      button.dataset.briteSubOriginalText = textNode.textContent;
    }

    var original = button.dataset.briteSubOriginalText;
    var dashIndex = original.lastIndexOf('—');
    if (dashIndex === -1) return;

    var prefix = original.slice(0, dashIndex + 1);
    textNode.textContent = prefix + ' ' + formatMoney(priceCents, moneyFormat, currency);

    var compareEl = button.querySelector('[data-brite-compare-price]');
    if (compareEl) {
      if (comparePriceCents > priceCents) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function setStickyButtonPrice(button, priceCents, comparePriceCents, moneyFormat, currency) {
    if (!button) return;
    var contentEl = button.querySelector('.add-to-cart-text__content');
    if (!contentEl) return;

    var textEl = Array.prototype.find.call(contentEl.children, function (child) {
      return child.tagName === 'SPAN' && !child.hasAttribute('ref');
    });
    if (!textEl) return;

    if (button.dataset.briteSubOriginalText === undefined) {
      button.dataset.briteSubOriginalText = textEl.textContent;
    }

    var original = button.dataset.briteSubOriginalText;
    var dashIndex = original.lastIndexOf('—');
    if (dashIndex === -1) return;

    var prefix = original.slice(0, dashIndex + 1);
    textEl.textContent = prefix + ' ' + formatMoney(priceCents, moneyFormat, currency);

    var compareEl = contentEl.querySelector('[data-brite-compare-price]');
    if (compareEl) {
      if (comparePriceCents > priceCents) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function setPriceBlock(productId, priceCents, comparePriceCents, moneyFormat, currency) {
    var priceBlock = document.querySelector('[data-brite-price][data-main-product-id="' + productId + '"]');
    if (!priceBlock) return;

    var amountEl = priceBlock.querySelector('[data-brite-price-amount]');
    var compareEl = priceBlock.querySelector('[data-brite-price-compare]');
    var perUnitEl = priceBlock.querySelector('[data-brite-price-per-unit]');
    var cansPerPack = parseInt(priceBlock.dataset.cansPerPack, 10) || 1;
    var perCan = Math.round(priceCents / cansPerPack);

    if (amountEl) amountEl.textContent = formatMoney(priceCents, moneyFormat, currency);
    if (compareEl) {
      if (comparePriceCents > priceCents) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(comparePriceCents, moneyFormat, currency);
      } else {
        compareEl.hidden = true;
      }
    }
    if (perUnitEl) perUnitEl.textContent = formatMoney(perCan, moneyFormat, currency);
  }

  function getSelectedSellingPlanId(widget) {
    var selectedRadio = widget.querySelector('[data-brite-sub-radio]:checked');
    if (!selectedRadio || selectedRadio.value !== 'subscription') return null;

    var select = widget.querySelector('[data-brite-sub-frequency]');
    if (!select || !select.value) return null;

    var id = parseInt(select.value, 10);
    return isNaN(id) ? null : id;
  }

  function setFormSellingPlan(form, sellingPlanId) {
    if (!form) return;
    var input = form.querySelector('input[name="selling_plan"]');

    if (sellingPlanId) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      input.value = sellingPlanId;
    } else if (input) {
      input.remove();
    }
  }

  function hasQuantityPicker(productId) {
    return !!document.querySelector('[data-brite-quantity-picker][data-main-product-id="' + productId + '"]');
  }

  function syncWidget(widget) {
    try {
      var productId = widget.dataset.mainProductId;
      if (!productId) return;

      if (hasQuantityPicker(productId)) return;

      var basePrice = parseInt(widget.dataset.basePrice, 10);
      if (!basePrice) return;

      var tier1Percent = parseFloat(widget.dataset.tier1Percent) || 0;
      var moneyFormat = widget.dataset.moneyFormat || '{{amount}}';
      var currency = widget.dataset.currency || '';

      var sellingPlanId = getSelectedSellingPlanId(widget);
      var isSubscription = !!sellingPlanId;

      var priceCents = isSubscription
        ? Math.round(basePrice * (1 - tier1Percent / 100))
        : basePrice;
      var comparePriceCents = priceCents < basePrice ? basePrice : 0;

      var scope = widget.closest('.brite-product') || document;
      var form = scope.querySelector(
        'product-form-component[data-product-id="' + productId + '"] form[data-type="add-to-cart-form"]'
      );
      setFormSellingPlan(form, sellingPlanId);

      var formButton = form && form.querySelector('[ref="addToCartButton"]');
      setButtonPrice(formButton, priceCents, comparePriceCents, moneyFormat, currency);
      setPriceBlock(productId, priceCents, comparePriceCents, moneyFormat, currency);

      var stickyButton = document.querySelector(
        'sticky-add-to-cart[data-product-id="' + productId + '"] [ref="addToCartButton"]'
      );
      setStickyButtonPrice(stickyButton, priceCents, comparePriceCents, moneyFormat, currency);
    } catch (error) {
      console.error('[brite-subscription-button-sync] failed', error);
    }
  }

  function findMainWidget(productId) {
    return document.querySelector('[data-brite-subscription][data-main-product-id="' + productId + '"]');
  }

  function setCheckedRadio(root, selector, value) {
    var radio = root.querySelector(selector + '[value="' + value + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncStickyPills(pills) {
    try {
      var productId = pills.dataset.mainProductId;
      if (!productId) return;

      if (hasQuantityPicker(productId)) return;

      var basePrice = parseInt(pills.dataset.basePrice, 10);
      if (!basePrice) return;

      var tier1Percent = parseFloat(pills.dataset.tier1Percent) || 0;
      var tier1Badge = '';
      var cansPerPack = 0;
      var perUnitText = '';
      var moneyFormat = pills.dataset.moneyFormat || '{{amount}}';
      var currency = pills.dataset.currency || '';
      var sellingPlan = pills.dataset.sellingPlan;
      var isSubscription;

      var mainWidget = findMainWidget(productId);
      if (mainWidget) {
        basePrice = parseInt(mainWidget.dataset.basePrice, 10) || basePrice;
        tier1Percent = parseFloat(mainWidget.dataset.tier1Percent) || 0;
        tier1Badge = mainWidget.dataset.tier1Badge || '';
        cansPerPack = parseInt(mainWidget.dataset.cansPerPack, 10) || 0;
        perUnitText = mainWidget.dataset.perUnitText || '';
        moneyFormat = mainWidget.dataset.moneyFormat || moneyFormat;
        currency = mainWidget.dataset.currency || currency;

        var mainSellingPlan = getSelectedSellingPlanId(mainWidget);
        isSubscription = !!mainSellingPlan;
        if (mainSellingPlan) sellingPlan = mainSellingPlan;

        var mainRadio = mainWidget.querySelector('[data-brite-sub-radio]:checked');
        if (mainRadio) setCheckedRadio(pills, '[data-brite-sub-sticky-radio]', mainRadio.value);
      } else {
        var selectedRadio = pills.querySelector('[data-brite-sub-sticky-radio]:checked');
        isSubscription = !!selectedRadio && selectedRadio.value === 'subscription' && !!sellingPlan;
      }

      var discountCents = Math.round((basePrice * tier1Percent) / 100);
      var subPrice = basePrice - discountCents;
      var priceCents = isSubscription ? subPrice : basePrice;
      var comparePriceCents = priceCents < basePrice ? basePrice : 0;

      if (mainWidget) {
        var sepHtml =
          '<span class="sticky-add-to-cart__sub-pill-sep">' +
          '<svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="2" cy="2" r="2" fill="#B5B5B5"/></svg></span>';

        var subPerUnit = cansPerPack ? Math.round(subPrice / cansPerPack) : subPrice;
        var basePerUnit = cansPerPack ? Math.round(basePrice / cansPerPack) : basePrice;

        var subPriceEl = pills.querySelector('[data-brite-sub-sticky-price]');
        if (subPriceEl) {
          subPriceEl.innerHTML =
            formatMoney(subPrice, moneyFormat, currency) + ' ' + sepHtml + ' ' +
            formatMoney(subPerUnit, moneyFormat, currency) + ' ' + perUnitText;
        }

        var onetimePriceEl = pills.querySelector('[data-brite-sub-sticky-onetime-price]');
        if (onetimePriceEl) {
          onetimePriceEl.innerHTML =
            formatMoney(basePrice, moneyFormat, currency) + ' ' + sepHtml + ' ' +
            formatMoney(basePerUnit, moneyFormat, currency) + ' ' + perUnitText;
        }

        var badgeEl = pills.querySelector('[data-brite-sub-sticky-badge]');
        if (badgeEl) {
          if (tier1Badge && tier1Percent > 0) {
            badgeEl.textContent = tier1Badge;
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }
      }

      var bar = pills.closest('.sticky-add-to-cart__bar');
      var form = bar && bar.querySelector('form[data-type="add-to-cart-form"]');
      setFormSellingPlan(form, isSubscription ? sellingPlan : null);

      var formButton = form && form.querySelector('[ref="addToCartButton"]');
      setButtonPrice(formButton, priceCents, comparePriceCents, moneyFormat, currency);
    } catch (error) {
      console.error('[brite-subscription-button-sync] failed', error);
    }
  }

  function initStickyPills() {
    document.querySelectorAll('[data-brite-sub-sticky]').forEach(function (pills) {
      syncStickyPills(pills);

      pills.addEventListener('change', function (event) {
        if (!event.target.matches('[data-brite-sub-sticky-radio]')) return;
        var mainWidget = findMainWidget(pills.dataset.mainProductId);
        if (mainWidget) setCheckedRadio(mainWidget, '[data-brite-sub-radio]', event.target.value);
        syncStickyPills(pills);
      });

      var mainWidget = findMainWidget(pills.dataset.mainProductId);
      if (mainWidget) {
        mainWidget.addEventListener('change', function (event) {
          if (!event.target.matches('[data-brite-sub-radio], [data-brite-sub-frequency]')) return;
          syncStickyPills(pills);
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-brite-subscription]').forEach(function (widget) {
      syncWidget(widget);

      widget.addEventListener('change', function (event) {
        if (!event.target.matches('[data-brite-sub-radio], [data-brite-sub-frequency]')) return;
        syncWidget(widget);
      });
    });

    initStickyPills();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[ref="addToCartButton"]');
    if (!button) return;

    var root = button.closest('product-form-component');
    var productId = root && root.dataset.productId;
    if (!productId) return;

    var bar = root.closest('.sticky-add-to-cart__bar');
    var pills = bar && bar.querySelector('[data-brite-sub-sticky]');
    if (pills) {
      syncStickyPills(pills);
    } else {
      var widget = findMainWidget(productId);
      if (widget) syncWidget(widget);
    }
  }, { capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Brite product features price sync */
(function () {
  function findMainWidget(productId) {
    return document.querySelector('[data-brite-subscription][data-main-product-id="' + productId + '"]');
  }

  function syncProductFeatures(el) {
    try {
      var productId = el.dataset.mainProductId;
      if (!productId) return;

      var pricePerCan = parseInt(el.dataset.pricePerCan, 10);
      if (!pricePerCan) return;

      var comparePricePerCan = parseInt(el.dataset.comparePricePerCan, 10) || 0;
      var moneyFormat = el.dataset.moneyFormat || '{{amount}}';
      var currency = el.dataset.currency || '';

      var priceEl = el.querySelector('[data-brite-features-price]');
      var compareEl = el.querySelector('[data-brite-features-compare]');

      var mainWidget = findMainWidget(productId);
      console.log('[brite-features-sync] syncProductFeatures -> mainWidget found?', !!mainWidget);
      var isSubscription = true;
      if (mainWidget) {
        var selectedRadio = mainWidget.querySelector('[data-brite-sub-radio]:checked');
        console.log('[brite-features-sync] syncProductFeatures -> selectedRadio value =', selectedRadio && selectedRadio.value);
        isSubscription = !selectedRadio || selectedRadio.value === 'subscription';
      }
      console.log('[brite-features-sync] syncProductFeatures -> isSubscription =', isSubscription);

      if (priceEl) {
        priceEl.classList.toggle('brite-product-features__price--plain', !isSubscription);
        priceEl.textContent = formatMoney(
          isSubscription ? pricePerCan : comparePricePerCan || pricePerCan,
          moneyFormat,
          currency
        );
      }

      if (compareEl) {
        if (isSubscription && comparePricePerCan > pricePerCan) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(comparePricePerCan, moneyFormat, currency);
        } else {
          compareEl.hidden = true;
        }
      }
    } catch (error) {
      console.error('[brite-product-features-price-sync] failed', error);
    }
  }

  function init() {
    var elements = document.querySelectorAll('[data-brite-product-features]');
    console.log('[brite-features-sync] init, found', elements.length, 'element(s)');

    elements.forEach(function (el) {
      syncProductFeatures(el);

      var mainWidget = findMainWidget(el.dataset.mainProductId);
      console.log('[brite-features-sync] init -> mainWidget for listener?', !!mainWidget, 'productId =', el.dataset.mainProductId);
      if (mainWidget) {
        mainWidget.addEventListener('change', function (event) {
          console.log('[brite-features-sync] mainWidget change event, target =', event.target);
          if (!event.target.matches('[data-brite-sub-radio]')) return;
          console.log('[brite-features-sync] mainWidget change matched, re-syncing');
          syncProductFeatures(el);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Brite free delivery - convert threshold to the active market currency */
(function () {
    function updateFreeDeliveryAmounts(root) {
        var scope = root || document;
        var elements = scope.querySelectorAll('.brite-free-delivery__amount[data-base-amount]');

        if (!elements.length) {
            return;
        }

        var currency = (window.Shopify && window.Shopify.currency) || {};
        var rate = parseFloat(currency.rate);
        var code = currency.active;

        if (isNaN(rate)) {
            rate = 1;
        }

        elements.forEach(function (element) {
            var baseAmount = parseFloat(element.getAttribute('data-base-amount'));

            if (isNaN(baseAmount)) {
                return;
            }

            var amount = Math.round(baseAmount * rate);

            if (code) {
                try {
                    element.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined, {
                        style: 'currency',
                        currency: code,
                        maximumFractionDigits: 0
                    }).format(amount);
                } catch (error) {
                    element.textContent = amount + ' ' + code;
                }
            }

            element.setAttribute('data-ready', '');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            updateFreeDeliveryAmounts();
        });
    } else {
        updateFreeDeliveryAmounts();
    }

    document.addEventListener('shopify:section:load', function (event) {
        updateFreeDeliveryAmounts(event.target);
    });
})();

/* Cart drawer Trustpilot re-init */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var timer;

  function initTrustpilot(attempt) {
    attempt = attempt || 0;

    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
      if (attempt < 40) {
        setTimeout(function () {
          initTrustpilot(attempt + 1);
        }, 150);
      }
      return;
    }

    drawer.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
      if (widget.querySelector('iframe') || widget.dataset.tpInit) return;
      widget.dataset.tpInit = '1';
      window.Trustpilot.loadFromElement(widget, true);
    });
  }

  function scheduleInit() {
    clearTimeout(timer);
    timer = setTimeout(initTrustpilot, 100);
  }

  new MutationObserver(scheduleInit).observe(drawer, { childList: true, subtree: true });

  document.addEventListener('theme-drawer:open', scheduleInit);
  scheduleInit();
})();

/* Market switcher modal */
document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-market-modal-open]');
  if (opener) {
    var modal = document.getElementById(opener.getAttribute('data-market-modal-open'));
    if (modal && typeof modal.showModal === 'function' && !modal.open) modal.showModal();
    return;
  }

  var option = event.target.closest('[data-market-country]');
  if (option) {
    var form = option.closest('form');
    var language = option.getAttribute('data-market-language');
    form.querySelector('[name="country_code"]').value = option.getAttribute('data-market-country');
    form.querySelector('[name="language_code"]').value = language;
    form.querySelector('[name="language_code"]').disabled = !language;

    var returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) {
      var returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('section_id');
      returnTo.value = returnUrl.pathname + returnUrl.search;
    }

    form.submit();
    return;
  }

  var closer = event.target.closest('[data-market-modal-close]');
  if (closer) {
    var openModal = closer.closest('.market-modal');
    if (openModal) openModal.close();
    return;
  }

  if (event.target.matches('.market-modal[open]')) event.target.close();
});

/* Brite DE - German price format (48,00 €) on brite.de */
(function () {
    if (!/(^|\.)brite\.de$/i.test(window.location.hostname)) return;

    var PRICE_PATTERN = /€\s?(\d{1,3}(?:[.   ]\d{3})+(?:,\d+)?|\d+(?:,\d+)?)(?:\s?EUR\b)?/g;
    var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, TEMPLATE: 1 };

    function convertTextNode(node) {
        var value = node.nodeValue;
        if (!value || value.indexOf('€') === -1) return;

        var converted = value.replace(PRICE_PATTERN, '$1 €');
        if (converted !== value) node.nodeValue = converted;
    }

    function convertTree(root) {
        if (root.nodeType === 3) {
            if (!root.parentNode || !SKIP_TAGS[root.parentNode.nodeName]) convertTextNode(root);
            return;
        }

        if (root.nodeType !== 1 || SKIP_TAGS[root.nodeName]) return;

        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
            acceptNode: function (node) {
                return SKIP_TAGS[node.parentNode.nodeName] ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
            }
        });

        var node;
        while ((node = walker.nextNode())) convertTextNode(node);
    }

    function start() {
        convertTree(document.body);

        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'characterData') {
                    convertTree(mutation.target);
                    return;
                }

                mutation.addedNodes.forEach(convertTree);
            });
        }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.body) {
        start();
    } else {
        document.addEventListener('DOMContentLoaded', start);
    }
})();